import React, { useEffect, useRef, useState } from "react";
import { GoogleApiWrapper, Marker } from "google-maps-react";
import { Map } from "google-maps-react";
// import { useDispatch, useSelector } from "react-redux";

const Location = (props) => {
  const editAddress = localStorage.getItem('edit-address')
  const finalEditAdd = JSON.parse(editAddress)
  console.log("props", props.lat, props.lon);
  const [address, setAddress] = useState("");
  console.log(address, "ccp");
  const location = JSON.parse(editAddress) ? finalEditAdd?.location: "Dhaka, Bangladesh";
  const latitude =finalEditAdd ? finalEditAdd?.latitude : 23.777176;
  const longitude =finalEditAdd ? finalEditAdd?.longitude : 90.399452;

  const { google, onPlaceSelected, lat, lon, placeObject, setLocation } = props;

  console.log("placeObject", lat, lon, placeObject.name);
  const mapDivRef = useRef();

  useEffect(() => {
    refreshMap();
    var input = document.getElementById("pac-input");
    input.value = location;
    if (input) {
      input.value = location;
    }
  }, []);
  useEffect(() => {
    const data = {
      location: address === "" ? location : address,
      latitude: lat ? lat : latitude,
      longitude: lon ? lon : longitude,
    };
    // localStorage.setItem('address',JSON.stringify(data))
  }, [lat, lon, address]);

  function getReverseGeocodingData(map, marker, infowindow) {
    var latlng = new google.maps.LatLng(lat, lon);

    var infowindowContent = document.getElementById("infowindow-content");
    infowindow.setContent(infowindowContent);

    marker.setPosition(latlng);
    marker.setVisible(true);

    var address = "";
    if (placeObject?.address_components) {
      address = [
        (placeObject.address_components[0] &&
          placeObject.address_components[0].short_name) ||
          "",
        (placeObject.address_components[1] &&
          placeObject.address_components[1].short_name) ||
          "",
        (placeObject.address_components[2] &&
          placeObject.address_components[2].short_name) ||
          "",
      ].join(" ");
    }

    var input = document.getElementById("pac-input");

    if (
      infowindowContent.children["place-icon"] &&
      infowindowContent.children["place-name"] &&
      infowindowContent.children["place-address"]
    ) {
      infowindowContent.children["place-icon"].src = placeObject.icon;
      infowindowContent.children["place-name"].textContent = placeObject.name;
      infowindowContent.children["place-address"].textContent = address;
      infowindow.open(map, marker);
    }

    if (input) {
      input.value = placeObject.name + " - " + address;
    }
  }

  function refreshMap() {
    var map = new google.maps.Map(document.getElementById("mapDiv"), {
      center: {
        lat: lat || latitude,
        lng: lon || longitude,
      },
      zoom: 13,
    });

    var input = document.getElementById("pac-input");

    var options = {
      //   bounds: dubaiBounds,
      types: ["establishment"],
      componentRestrictions: {
        // country: 'AE',
      },
      strictBounds: false,
    };
    var autocomplete = new google.maps.places.Autocomplete(input, options);
    /// show on map
    autocomplete.bindTo("bounds", map);

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(["address_components", "geometry", "icon", "name"]);

    var infowindow = new google.maps.InfoWindow();
    var infowindowContent = document.getElementById("infowindow-content");
    infowindow.setContent(infowindowContent);
    var marker = new google.maps.Marker({
      map: map,
      anchorPoint: new google.maps.Point(0, -29),
    });

    autocomplete.addListener("place_changed", function () {
      infowindow.close();
      marker.setVisible(false);
      var place = autocomplete.getPlace();
      onPlaceSelected(place);
      if (!place.geometry) {
        window.alert("No details available for input: '" + place.name + "'");
        return;
      }
      marker.setPosition(place.geometry.location);
      marker.setVisible(true);
      // clientInput.address = place.name
      var address = "";
      if (place.address_components) {
        address = [
          (place.address_components[0] &&
            place.address_components[0].short_name) ||
            "",
          (place.address_components[1] &&
            place.address_components[1].short_name) ||
            "",
          (place.address_components[2] &&
            place.address_components[2].short_name) ||
            "",
        ].join(" ");
      }

      infowindowContent.children["place-icon"].src = place.icon;
      infowindowContent.children["place-name"].textContent = place.name;
      infowindowContent.children["place-address"].textContent = address;
      infowindow.open(map, marker);
      console.log("fields", place.name + address);
      // dispatch()
      // clientInput.address = place.name
    });

    if (placeObject && Object.keys(placeObject).length > 0) {
      setTimeout(() => getReverseGeocodingData(map, marker, infowindow), 2000);
    }
  }
  // -----------------new code---------------------
  const [searchQuery, setSearchQuery] = useState("");
  const [markers, setMarkers] = useState([]);
  const [markerPosition, setMarkerPosition] = useState({
    lat: lat || 23.8103,
    lng: lon || 90.4125,
  });

  useEffect(() => {
    if (lat && lon) {
      setMarkerPosition({
        lat: lat,
        lng: lon,
      });
      //   dispatch(GetClientInput("latitude", lat));
      //   dispatch(GetClientInput("longitude", lon));
      //   dispatch(GetClientInput("location", placeObject.name));
    }
    // setLocation({
    //   lat: markerPosition.lat,
    //   lon: markerPosition.lng,
    // });
  }, [lat, lon, placeObject]);

  const handleMarkerDrag = (t, marker) => {
    console.log(t, marker, "handleMarkerDrag");
    const newPosition = {
      lat: marker.getPosition().lat(),
      lng: marker.getPosition().lng(),
    };
       setLocation({
      lat: markerPosition.lat,
      lon: markerPosition.lng,
    });


    const geocoder = new window.google.maps.Geocoder();

    const getLocName = (newPosition) => {
      console.log("newPosition :", newPosition);
      geocoder.geocode({ latLng: newPosition }, function (results, status) {
        console.log("results :", results);
        if (status === window.google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // let adrs_comp = results[0].address_components, loc_name, area_name;
            var input = document.getElementById("pac-input");
            if (input) {
              input.value = results[0].formatted_address;
              setAddress(results[0].formatted_address);
              console.log(results[0].formatted_address,'hh')
              //   dispatch(GetClientInput("latitude", newPosition.lat));
              //   dispatch(GetClientInput("longitude", newPosition.lng));
              //   dispatch(
              //     GetClientInput("location", results[0].formatted_address)
              //   );
            }
            // for(let  i = 0; i < adrs_comp.length; i++) {
            //     if(adrs_comp[i].types[0] === "locality" ) {
            //         loc_name = adrs_comp[i].long_name;
            //         console.log('loc name :',loc_name )
            //     }
            //     if(adrs_comp[i].types[0] === "administrative_area_level_1" ) {
            //         area_name = adrs_comp[i].long_name;
            //         console.log('area_name :',area_name )
            //     }
            // }
          }
        }
      });
    };

    getLocName(newPosition);
    setMarkerPosition(newPosition);
  };
  const onMapClick = (mapProps, map, event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const newMarker = { lat, lng };
    setMarkers([markers, newMarker]);
    console.log("coord", markers);
  };
  const onSearchChange = (e) => {
    setSearchQuery(e);
  };
  useEffect(()=>{
    
    
    // if(JSON.parse(editAddress)){
    //   localStorage.setItem('address',JSON.stringify(finalEditAdd))
    // }else{
      const data = {
        location: placeObject.name === undefined ? location : placeObject.name,
        latitude: lat ? lat : latitude,
        longitude: lon ? lon : longitude,
      };
      localStorage.setItem('address',JSON.stringify(data))
    // }
    
  },[address,lat,lon])

  return (
    <>
      {/* {!props?.hideSearch && ( */}
      <input
        id="pac-input"
        // value={location}
        type="text"
        placeholder="Enter a location"
        className="ant-input map-input"
        style={{ marginBottom: "20px", width: "100%" }}
      />

      <div
        className="map"
        id="mapDiv"
        ref={mapDivRef}
        style={{ display: "none" }}
      ></div>

      {/* <div className="" style={{ position: "relative", height: "500px" }}>
        <Map
          google={google}
          zoom={14}
          
          center={{
            lat: latitude,
            lng: longitude,
          }}
          dragable={true}
          onClick={onMapClick}
        >
          <Marker
            draggable={true}
            onDragend={handleMarkerDrag}
            // position={markerPosition}
            position={{
              lat: latitude,
              lng: longitude,
            }}
          />
        </Map>
      </div> */}
    </>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyCueZ-BzQugLmj0J1h3ODLAtoeAlLUuogk",
})(Location);
